import type { JSX } from "react";
import { defineMessage, MessageDescriptor } from "react-intl";
export enum MeetingPageStage {
    SelectClient,
    Prepare,
    Room,
    LiftOff,
}

export type StageRenderer = () => JSX.Element;

export const stageNumbers = Object.values(MeetingPageStage).filter((val) => typeof val === "number") as number[];

export type StageDescriptor = {
    stage: MeetingPageStage;
    title: MessageDescriptor;
};

export const stageDescriptors: StageDescriptor[] = [
    {
        stage: MeetingPageStage.SelectClient,
        title: defineMessage({ id: "meetingPage.stages.selectClient", defaultMessage: "Select client" }),
    },
    {
        stage: MeetingPageStage.Prepare,
        title: defineMessage({ id: "meetingPage.stages.prepare", defaultMessage: "Prepare" }),
    },
    {
        stage: MeetingPageStage.Room,
        title: defineMessage({ id: "meetingPage.stages.room", defaultMessage: "Meeting" }),
    },
];

export type VideoBackgroundEffectType = "none" | "blur";

export type VideoBackgroundBlurEffectParams = {
    level: "light" | "strong";
};

export type VideoBackgroundEffect = {
    type: VideoBackgroundEffectType;
    params?: VideoBackgroundBlurEffectParams;
};

export type MeetingPageSettings = {
    stage: MeetingPageStage;
    audio: boolean;
    video: boolean;
    displayName: string;
    videoBackgroundEffect: VideoBackgroundEffect;
};

export const defaultMeetingPageSettings: MeetingPageSettings = {
    stage: MeetingPageStage.SelectClient,
    audio: true,
    video: true,
    displayName: null,
    videoBackgroundEffect: {
        type: "none",
    },
};
